import { createTheme } from '@mui/material/styles'
import darkScrollbar from '@mui/material/darkScrollbar'
import base from './base'

const theme = createTheme(base, {
    name: "Like My Drive",
    logo: "lmdLogo.svg",
    palette: {
        secondary: {
            main: '#4eb0f0',
            dark: '#3f7aa0',
            contrastText: '#ffffff',
        },
    },
    header: {
        selector: {
            color: "#13bfde",
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: darkScrollbar(),
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        color: '#13bfde',
                    },
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        color: "#13bfde"
                    },
                },
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        color: "#13bfde"
                    },
                }
            }
        },
    },
});
export default theme
